import React, { useMemo, useState } from "react";
import DataTable from "components/DataTable";
import PageWrapper from "components/PageWrapper";
import { useTableData } from "../../hooks/useTableData";
import { moneyTransferReportsConfig } from "config/tableConfigs";
import { useSession } from "hooks/useSession";

const MoneyTransferReportsPage = () => {
  const { userid, role } = useSession();

  const getLast7Days = () => {
    const t = new Date();
    const p = new Date();
    p.setDate(t.getDate() - 1);
    return {
      start: p.toISOString().split("T")[0],
      end: t.toISOString().split("T")[0],
    };
  };

  const { start, end } = getLast7Days();

  const [apiUrl, setApiUrl] = useState(
    `https://api.mokshiq.in/get_dmt_report?user=${userid}&filter_date=${start}&end_date=${end}`
  );

  const tableData = useTableData(apiUrl, moneyTransferReportsConfig);

  const handleDateFilter = (s, e) => {
    setApiUrl(
      `https://api.mokshiq.in/get_dmt_report?user=${userid}&filter_date=${s}&end_date=${e}`
    );
  };

 const filteredConfig = useMemo(() => {
  const base = { ...moneyTransferReportsConfig };

  const roleMap = {
    Retailer: [
      "id",
      "refNo",
      "ackNo",
      "transectionType",
      "product",
      "number",
      "amount",
      "status",
      "createdAt",
      "openingBalanceBc",
      "bcCommission",
      "bcTds",
      "bcCharge",
      "bcGst",
      "closingBalanceBc",
      "bankRrn",
      "aadharNumber"
    ],

    Distributer: [
      "id",
      "refNo",
      "ackNo",
      "transectionType",
      "product",
      "number",
      "amount",
      "status",
      "createdAt",
      "openingBalanceDistributor",
      "commission",
      "tds",
      "charge",
      "gst",
      "closingBalanceDistributor",
      "bankRrn",
      "aadharNumber"
    ],

    "Super Distributer": [
      "id",
      "refNo",
      "ackNo",
      "transectionType",
      "product",
      "number",
      "amount",
      "status",
      "createdAt",
      "openingBalanceSuperDistributor",
      "commission",
      "tds",
      "charge",
      "gst",
      "closingBalanceSuperDistributor",
      "bankRrn",
      "aadharNumber"
    ],

    Admin: [
      "id",
      "bcName",
      "product",
      "amount",
      "openingBalanceAdmin",
      "commissionAdmin",
      "tdsAdmin",
      "chargeAdmin",
      "gstAdmin",
      "closingBalanceAdmin",
      "openingBalanceBc",
      "bcCommission",
      "bcTds",
      "bcCharge",
      "bcGst",
      "closingBalanceBc",
      "number",
      "status",
      "walletTxn",
      "txnFlow",
      "refNo",
      "ackNo",
      "bankRrn",
      "aadharNumber",
      "createdAt"
    ],

    "Main Admin": base.columns.map(c => c.key)
  };

  const allowed = roleMap[role] || [];
  base.columns = base.columns.filter(c => allowed.includes(c.key));
  return base;
}, [role]);


  return (
    <PageWrapper
      config={moneyTransferReportsConfig}
      onDateFilter={handleDateFilter}
    >
      <DataTable
        config={filteredConfig}
        tableData={tableData}
        onView={() => {}}
        onEdit={() => {}}
        onDelete={() => {}}
        onExport={() => {}}
        onDeleteSelected={() => {}}
      />
    </PageWrapper>
  );
};

export default MoneyTransferReportsPage;
